<template>
  <div class='userDefined'>
    <Spin size="large" fix v-if="spinShow"></Spin>
    <!-- 分类组件 -->
    <classification @changeClass='changeClass($event)' :classificationList='classificationList' />
    <div v-if="commonShow">
      <!-- 提示 -->
      <div class="title w f32 color-black font-weight-b">共有<span class="color-green" >{{common.length}}</span>个符合条件的基础课程</div>
      <!-- 课程列表 -->
      <div class="w">
        <course :courseList='common' :curriculaVariable='curriculaVariable' @toDetail='toCourseDetail($event)' @joinCourse='joinCourse($event)' :type='type' />
      </div>
    </div>
    <div v-if="kernelShow">
      <!-- 提示 -->
      <div class="title w f32 color-black font-weight-b">共有<span class="color-green" >{{kernel.length}}</span>个符合条件的核心课程</div>
      <!-- 课程列表 -->
      <div class="w">
        <course :courseList='kernel' :curriculaVariable='curriculaVariable' @toDetail='toCourseDetail($event)' @joinCourse='joinCourse($event)' :type='type' />
      </div>
    </div>
    <div v-if="extendShow">
      <!-- 提示 -->
      <div class="title w f32 color-black font-weight-b">共有<span class="color-green" >{{extend.length}}</span>个符合条件的拓展课程</div>
      <!-- 课程列表 -->
      <div class="w">
        <course :courseList='extend' :curriculaVariable='curriculaVariable' @toDetail='toCourseDetail($event)' @joinCourse='joinCourse($event)' :type='type' />
      </div>
    </div>

  </div>
</template>

<script>
import classification from '@/components/classification'
import course from '@/components/course'

export default {
  name: 'userDefined',
  components: {
    classification,
    course
  },
  data () {
    return {
      type: 'userDefined',
      classificationList: [
        { title: '类型', class: [ { name: '全部' }, { name: '基础课程' }, { name: '核心课程' }, { name: '拓展课程' } ], activeIndex: 0 }
      ],
      courseList: [],
      commonShow: true,
      kernelShow: true,
      extendShow: true,
      common: [],
      kernel: [],
      extend: [],
      curriculaVariable: [],
      spinShow: true

    }
  },
  mounted () {
    this.init()
  },
  methods: {
    // 请求初始化
    async init () {
      await this.getCourse()
      if (this.$store.state.user) {
        await this.getRegistrationCenter()
      }
      this.spinShow = false
    },
    async getRegistrationCenter () {
      let res = await this.$tkParse.getList('/classes/registrationCenter', {
        params: {
          where: {
            user: this.$store.state.user.objectId
          }
        }
      })
      if (!res.length) {
        this.curriculaVariable = []
        return
      }
      let arr = []
      res[0].course.forEach(item => {
        arr.push(item.id)
      })
      this.curriculaVariable = arr
    },
    async getCourse () {
      // 获取课程
      let res = await this.$tkParse.getList('/classes/course', {
        params: { // url参数
          include: 'preinstallMajor', // 如果有多个关联都需要查询，用英文逗号分隔,例如：'pointer1,pointer2'
          where: {
            putaway: true
          }
        }
      })
      let common = []
      let kernel = []
      let extend = []
      res.forEach((item, index) => {
        if (item.type === '00') { common.push(item) }
        if (item.type === '01') { kernel.push(item) }
        if (item.type === '02') { extend.push(item) }
      })
      this.common = common
      this.kernel = kernel
      this.extend = extend
      this.courseList = res
    },
    async joinCourse (id) {
      if (this.$login(this)) { return }
      let res = await this.$tkParse.getList('/classes/registrationCenter', {
        params: {
          where: {
            user: this.$store.state.user.objectId
          }
        }
      })
      if (res.length) {
        let putData = res[0].course
        if (putData.indexOf(id) !== -1) {
          this.$Message.warning({ content: '请勿重复添加' })
          return
        }
        putData.push({
          type: '1',
          id: id
        })
        let put = await this.$tkParse.put(`/classes/registrationCenter/${res[0].objectId}`, {
          course: putData
        })
        if (put) {
          this.$Message.success('添加成功')
          this.getRegistrationCenter()
          this.$store.commit('setCarNum', this.$store.state.carNum + 1)
        } else {
          this.$Message.error('添加失败')
        }
        return
      }

      let postData = {
        user: this.$store.state.user.objectId,
        course: [
          {
            type: '1',
            id: id
          }
        ]
      }
      let post = await this.$tkParse.post('/classes/registrationCenter', postData)
      if (post) {
        this.$Message.success('添加成功')
        this.getRegistrationCenter()
        this.$store.commit('setCarNum', this.$store.state.carNum + 1)
      } else {
        this.$Message.error('添加失败')
      }
    },
    // 切换分类
    async changeClass (e) {
      this.classificationList[e.index].activeIndex = e.i
      // let id = this.classificationList[e.index].class[e.i].objectId
      if (e.index === 0) {
        this.commonShow = false
        this.kernelShow = false
        this.extendShow = false
        switch (e.i) {
          case 0:
            this.commonShow = true
            this.kernelShow = true
            this.extendShow = true
            break
          case 1:
            this.commonShow = true
            break
          case 2:
            this.kernelShow = true
            break
          case 3:
            this.extendShow = true
            break
          default:
            this.commonShow = true
            this.kernelShow = true
            this.extendShow = true
        }
      }
    },
    // 课程点击事件
    toCourseDetail (id) {
      this.$push({
        path: '/classDetail',
        query: {
          id: id,
          type: 'course'
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.userDefined{
  background-color: #F5F5F8;
  padding: 20px 0 70px;
}
//提示
.title{
  padding: 30px 0;
}
</style>
